import React, { useContext, useState } from "react";
import { FormContext } from "../context/FormContext";

const PropositoVisita = ({ onVolver, onPropositoSeleccionado }) => {
  const { formData, updateFormData } = useContext(FormContext);
  const [selectedService, setSelectedService] = useState(null); // Estado para el servicio seleccionado
  const [isContactologiaSelected, setIsContactologiaSelected] = useState(false); // Estado para determinar si Contactología fue seleccionada
  const [contactologiaResponse, setContactologiaResponse] = useState(null); // Estado para guardar la respuesta de Contactología

  // console.log("step 2 formData", formData);

  const handlePropositoSeleccionado = (proposito, id_servicio) => {
    // Actualizar el servicio seleccionado
    setSelectedService(proposito);

    // Guardar el propósito en el contexto
    updateFormData({
      ...formData,
      PropocitoCita: proposito,
      tpc_codigo: id_servicio,
    });

    // Verificar si es Contactología
    if (proposito === "CONTACTOLOGIA") {
      setIsContactologiaSelected(true);
    } else {
      setIsContactologiaSelected(false);
      onPropositoSeleccionado();
    }
  };

  const handleContactologiaResponse = (response) => {
    setContactologiaResponse(response);
    // Guardar la respuesta de Contactología en el contexto
    updateFormData({
      ...formData,
      flag_uso: response,
    });
    onPropositoSeleccionado();
  };

  // Validar si hay servicios disponibles
  const servicios = formData.TiendaSeleccionada?.servicios || [];
  if (!servicios.length) {
    return (
      <div className="col-md-6 pads0-768" id="booking-type">
        <div className="row booking-type-container">
          <div className="col-12 pads0 text-center">
            <h4>No hay servicios disponibles para esta tienda.</h4>
            <button onClick={onVolver} className="btn btn-secondary">
              Volver
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="col-md-6 pads0-768" id="booking-type">
      <div className="row booking-type-container">
        <div className="col-12 pads0">
          <div className="row justify-content-center">
            <div className="col-md-8 col-12 text-center">
              <h4>¿Cuál es el propósito de su visita?</h4>
              {servicios.map((servicio) => (
                <button
                  key={servicio.tpc_codigo}
                  className={`booking-type-opt ${
                    selectedService === servicio.tpc_denominacion ? "active-type" : ""
                  } ${formData.cadena === 'eco'? "booking-type-opt-eco" : "" }
                  ${formData.cadena === 'gmo'? "booking-type-opt-gmo" : "" }`}
                  onClick={() =>
                    handlePropositoSeleccionado(servicio.tpc_denominacion, servicio.tpc_codigo)
                  }
                >
                  {servicio.tpc_denominacion}
                </button>
              ))}

              {/* Mostrar botones adicionales si Contactología está seleccionada */}
              {isContactologiaSelected && (
                <div className="contactologia-question mt20 cl-type-question mt20">
                  <h4 className="mt40 mb20">¿Ha usado lentes de contacto antes?</h4>
                  <button
                    className="booking-type-answer-y"
                    onClick={() => handleContactologiaResponse(1)}
                  >
                    Sí
                  </button>
                  <button
                    className="booking-type-answer-n"
                    onClick={() => handleContactologiaResponse(0)}
                  >
                    No
                  </button>

                  <p className="disclaimer-proposito">Si estás usando lentes de contacto, recuerda quitarlas 24 horas antes de la visita para que tus ojos puedan relajarse antes del examen</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropositoVisita;
